const checkout = {
  name: 'checkout',
  data() {
    return {
      cardImage: `${process.env.VUE_APP_CDN}/images/card.svg`,
      cdn: process.env.VUE_APP_CDN,
      methodImage: '',
      logos: {
        'card-number': {
          src: "card",
          alt: "card number logo"
        },
        'expiry-date': {
          src: "exp-date",
          alt: "expiry date logo"
        },
        'cvv': {
          src: "cvv",
          alt: "cvv logo"
        }
      }
    }
  },
  methods: {
    onValidationChanged(event) {

      let e = event.element;

      if (event.isValid || event.isEmpty) {

        if (e == "card-number" && !event.isEmpty) {
          this.showPaymentMethodIcon();
        }
        this.setDefaultIcon(e);
        this.clearErrorIcon(e);
        this.clearErrorMessage(e);

      } else {

        if (e == "card-number") {
          this.clearPaymentMethodIcon();
        }

        this.setDefaultErrorIcon(e);
        this.setErrorIcon(e);
        this.setErrorMessage(e);
      }
    },
    clearErrorMessage(el) {
      let selector = ".error-message__" + el;
      let message = document.querySelector(selector);
      message.style.display = "none";
    },
    clearErrorIcon(el) {
      let logo = document.getElementById("icon-" + el + "-error");
      logo.style.removeProperty("display");
    },
    showPaymentMethodIcon(pm) {
      if (pm) this.methodImage = `${this.cdn}/images/${pm.toLowerCase()}.svg`;
    },
    clearPaymentMethodIcon() {
      this.methodImage = '';
    },
    setErrorMessage(el) {
      let selector = ".error-message__" + el;
      let message = document.querySelector(selector);
      message.style.display = "block";
    },
    setDefaultIcon(el) {
      let selector = "icon-" + el;
      let logo = document.getElementById(selector);
      logo.setAttribute("src", `${this.cdn}/images/${this.logos[el].src}.svg`);
    
      logo.setAttribute("alt", this.logos[el].alt);
    },
    setDefaultErrorIcon(el) {
      let selector = "icon-" + el;
      let logo = document.getElementById(selector);
      logo.setAttribute("src", `${this.cdn}/images/${this.logos[el].src}-error.svg`);
      logo.setAttribute("alt", this.logos[el].alt);
    },
    setErrorIcon(el) {
      let logo = document.getElementById("icon-" + el + "-error");
      logo.style.setProperty("display", "block");
    },
    paymentMethodChanged(event) {
      let pm = event.paymentMethod;
      let container = document.querySelector(".icon-container.payment-method");

      if (!pm) {
        this.clearPaymentMethodIcon(container);
      } else {
        this.clearErrorIcon("card-number");
        this.showPaymentMethodIcon(pm);
      }
    }
  }
};

export default {
  checkout
};